import { httpsCallable, FunctionsError } from 'firebase/functions';
import type {
  IssueSsoTokenRequest,
  IssueSsoTokenResponse,
} from '@kawai/shared';
import { functions } from '../firebase.js';

const issueSsoTokenCallable = httpsCallable<
  IssueSsoTokenRequest,
  IssueSsoTokenResponse
>(functions, 'authIssueSsoToken');

/**
 * T-08 SSO handover: tenant-portal → 各機能 apps への遷移時、actor 自身の uid +
 * 既存 claims で Custom Token を発行する Callable の薄いラッパ。
 *
 * 失敗時は FunctionsError を throw する。呼出側で fall-through（素のリンク遷移）して
 * UX を維持するか、ユーザーにエラーを見せるかを判断する。
 */
export async function callIssueSsoToken(
  input: IssueSsoTokenRequest,
): Promise<IssueSsoTokenResponse> {
  const res = await issueSsoTokenCallable(input);
  return res.data;
}

/**
 * `authIssueSsoToken` のエラーを portal 向け日本語メッセージに変換。純関数。
 */
export function ssoTokenErrorMessage(err: unknown): string {
  if (err instanceof FunctionsError) {
    switch (err.code) {
      case 'functions/unauthenticated':
        return 'セッションが切れました。再ログインしてください。';
      case 'functions/permission-denied':
        return '権限がありません。';
      case 'functions/invalid-argument':
        return `入力値に誤りがあります：${err.message}`;
      default:
        return `SSO トークン発行に失敗しました（${err.code}）。`;
    }
  }
  if (err instanceof Error) {
    return `SSO トークン発行に失敗しました：${err.message}`;
  }
  return 'SSO トークン発行に失敗しました。';
}
